import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'shopping-cart-minus',
  size: 24,
  node: [
    ['path', { d: 'M16 5h6', key: '1vod17' }],
    [
      'path',
      {
        d: 'm2.05 2.05 1.099-.028a1 1 0 011.008.815l2.69 14.347A1 1 0 007.83 18H18',
        key: 'ppm817',
      },
    ],
    ['path', { d: 'M4.564 5H12', key: '11wyuq' }],
    ['path', { d: 'M6.25 14h12.712a2 2 0 001.991-1.57l.514-3.113', key: 'zs85e' }],
    ['circle', { cx: '18', cy: '20', r: '2', key: 't9985n' }],
    ['circle', { cx: '8', cy: '20', r: '2', key: 'ckkr5m' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ShoppingCartMinus
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgNWg2IiAvPgogIDxwYXRoIGQ9Im0yLjA1IDIuMDUgMS4wOTktLjAyOGExIDEgMCAwMTEuMDA4LjgxNWwyLjY5IDE0LjM0N0ExIDEgMCAwMDcuODMgMThIMTgiIC8+CiAgPHBhdGggZD0iTTQuNTY0IDVIMTIiIC8+CiAgPHBhdGggZD0iTTYuMjUgMTRoMTIuNzEyYTIgMiAwIDAwMS45OTEtMS41N2wuNTE0LTMuMTEzIiAvPgogIDxjaXJjbGUgY3g9IjE4IiBjeT0iMjAiIHI9IjIiIC8+CiAgPGNpcmNsZSBjeD0iOCIgY3k9IjIwIiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shopping-cart-minus
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShoppingCartMinus = createLucideIcon(__iconData);

export default ShoppingCartMinus;
